import { render, staticRenderFns } from "./OrderProfile.vue?vue&type=template&id=78c5b7d4&scoped=true"
import script from "./OrderProfile.vue?vue&type=script&lang=js"
export * from "./OrderProfile.vue?vue&type=script&lang=js"
import style0 from "./OrderProfile.vue?vue&type=style&index=0&id=78c5b7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5b7d4",
  null
  
)

export default component.exports